/* eslint-disable jsx-a11y/anchor-is-valid */
import { Input } from "../../../components/core/Input";
import Select from "../../../components/others/Select/Select";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import StyledWrapper from "./style";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import LavorisService from "../../../services/LavorisService";
import { InputEmail } from "../../../components/others/InputEmail";
import { DatePicker } from "../../../components/others/DatePicker/index";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { useSearchParams } from "react-router-dom";
import { InsertEmployeeInputService, EmployeeInputService } from "../../../services/Company/Employee.type";
import AddressAutocomplete from "../../../components/others/MapsAutocomplete";
import { useModal } from "../../../hooks"
import { nationalities, maritalStatuses, sexs } from "../../../utils/dataOptionsUsers";
import { PhoneNumber } from "../../../components/others/PhoneNumber";
import CuilRadioInput from "../../../components/others/CuilRadioInput/CuilRadioInput";
import InputCuil from "../../../components/others/InputCuil/InputCuil";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import DocumentRadioInput from "../../../components/others/DocumentRadioInput/DocumentRadioInput";

type TProps = {
  refreshFunction?: Function;
}

export default function AddEmployee({ refreshFunction }: TProps) {
  const { register, handleSubmit, setValue, control, reset, watch, formState: { errors }, } = useForm<InsertEmployeeInputService>({
    mode: "all",
  });

  const { currentCompany, companies } = useSelector((state: RootState) => state.user);
  const { closeModal } = useModal();
  const [isLoading, setIsLoading] = useState(false)
  const [searchParams] = useSearchParams("");
  const [apiErrors, setSetApiErrors] = useState(false);
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const { showAlert } = useAlert()
  const [documentType, setDocumentType] = useState("DNI");


  const currentNationality = watch("nationality") || " "
  const supplementaryReference = watch("supplementaryReference") || " ";
  const cuil = watch("cuil") || " ";
  const [hasCuil, setHasCuil] = useState(true);
  const [dni, setDni] = useState("");
  const dniValue = cuil.replace(/[^0-9]/g, "").substring(2, 10);
  useEffect(() => {
    setDni(dniValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuil]);

  const LavorisInstance = LavorisService.getInstance();

  const getAddressComponentByType = (
    type: string,
    locationObj: google.maps.places.PlaceResult,
    fullAdrss: boolean = true,
  ): string | null => {
   
    const addressComponents = locationObj.address_components;
    if (fullAdrss) {
      const adrsName = locationObj.formatted_address || ""
      return adrsName
    }
    if (addressComponents) {
      for (let i = 0; i < addressComponents.length; i++) {
        const component = addressComponents[i];
        if (component.types.includes(type)) {
          return component.long_name;
        }
      }
    }
    return null;
  };

  //Handle Address
  const handleSelectAddress = (
    addressObject: google.maps.places.PlaceResult,
  ) => {
    setValue(
      "fullAddress",
      getAddressComponentByType("route", addressObject, true) +
      " "
    );
   
    setValue(
      "city",
      getAddressComponentByType("locality", addressObject, false) || "",
    );
    setValue(
      "province",
      getAddressComponentByType("administrative_area_level_1", addressObject, false) ||
      "",
    );
    setValue(
      "postalCode",
      getAddressComponentByType("postal_code", addressObject, false) || "",
    );

    if (
      addressObject &&
      addressObject.geometry &&
      addressObject.geometry.location
    ) {
      setLat(addressObject.geometry.location.lat().toString() || "");
      setLng(addressObject.geometry.location.lng().toString() || "");
    }
  };

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const onSubmit = async (data: InsertEmployeeInputService) => {
    setSetApiErrors(false);
    setIsLoading(true);
    let name = `${data.last_name.trim()}, ${data.first_name.trim()}`;
    const dateObj = new Date(data.birthDate);
    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();

    const formattedDate = `${day < 10 ? "0" : ""}${day}/${month < 10 ? "0" : ""
      }${month}/${year}`;
    const company = currentCompany ? currentCompany.id : companies[0].id;

    let insertdata: EmployeeInputService = {
      name: name.trim(),
      DNI: data.DNI.trim().length === 0 ? dni : data.DNI,
      cuil:
        data.cuil === undefined || data.cuil === "" ? "Pendiente" : data.cuil,
      birthDate: formattedDate,
      position: "OTROS",
      positionName: data.positionName,
      company: company,
      fullAddress: data.fullAddress,
      supplementaryReference: data.supplementaryReference,
      nationality:
        data.nationality === "OTRO" && data.nationalityOther
          ? data.nationalityOther
          : data.nationality,
      city: data.city,
      province: data.province,
      postalCode: data.postalCode,
      phoneNumber: data.phoneNumber,
      email: data.email.trim(),
      sex: data.sex,
      maritalStatus: data.maritalStatus,
      lat: lat,
      lng: lng,
    };

    await LavorisInstance.CompanyServices.addEmployee(insertdata)
      .then(() => {
        closeModal("AddModal");
        refreshFunction?.();
      })
      .catch((err) => {
        console.log(err);
        showAlert(getErrorMessage({ title: "Error al crear el empleado", err }));
        setSetApiErrors(true);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <StyledWrapper.FormContainer>
        <Input
          type="text"
          label="Apellido"
          fieldName="last_name"
          register={register}
          error={errors?.last_name}
          required
        />
        <Input
          type="text"
          label="Nombre"
          fieldName="first_name"
          register={register}
          error={errors?.first_name}
          required
        />

        <CuilRadioInput hasCuil={hasCuil} setHasCuil={setHasCuil} />
        {hasCuil ? (
          <>
            <InputCuil
              label="CUIL -Sin espacios ni guiones-"
              fieldName="cuil"
              register={register}
              error={errors?.cuil}
              required={hasCuil}
              readOnly={!hasCuil}
            />
            <Input
              type="text"
              label="DNI"
              fieldName="DNI"
              register={register}
              error={errors?.DNI}
              readOnly={true}
              value={dni}
            />
          </>
        ) : (
          <>
              <DocumentRadioInput
                documentType={documentType}
                setDocumentType={setDocumentType}
              />
          {documentType === "DNI" ? (
            <Input
              type="text"
              label="DNI"
              fieldName="DNI"
              register={register}
              error={errors?.DNI}
              required
              pattern="^[0-9]*$" // Solo números para DNI
            />
          ) : (
            <Input
              type="text"
              label="Pasaporte"
              fieldName="DNI"
              register={register}
              error={errors?.DNI}
              required
              pattern="^[a-zA-Z0-9]*$" // Números y letras para Pasaporte
            />
          )}
          </>
        )}

        <Select
          fieldName="nationality"
          label="Nacionalidad"
          options={nationalities}
          register={register}
          error={errors?.nationality}
          required
          styles="rounded w-full h-[50px]"
        />

        {currentNationality === "OTRO" && (
          <>
            <p>
              Si su nacionalidad no se encuentra entre las opciones, por favor
              ingresela*
            </p>
            <Input
              type="text"
              fieldName="nationalityOther"
              label="Nacionalidad"
              register={register}
              error={errors?.nationalityOther}
              required
            />
          </>
        )}

        <DatePicker
          fieldName="birthDate"
          label={"Fecha de Nacimiento"}
          minDate={100}
          maxDate={18}
          control={control}
          required
          error={errors?.birthDate}
        />
        <Select
          fieldName="sex"
          label="Sexo"
          options={sexs}
          register={register}
          error={errors?.sex}
          required
          styles="rounded w-full h-[50px]"
        />
        <Select
          fieldName="maritalStatus"
          label="Estado Civil"
          options={maritalStatuses}
          register={register}
          error={errors?.maritalStatus}
          required
          styles="rounded w-full h-[50px]"
        />
        
        <AddressAutocomplete
          onSelectAddress={handleSelectAddress}
          type="text"
          label="GEOLOCALIZAR DIRECCION (calle y numero unicamente)"
          fieldName="fullAddress"
          error={errors?.fullAddress}
          required
        />
        <Input
          type="text"
          label="Referencia Adicional importante ( Ejemplo: Número de calle, Número de departamento,Número de piso  M:12 C:8, Barrio)"
          fieldName="supplementaryReference"
          register={register}
          error={errors?.supplementaryReference}
          //placeholder="Ejemplo: Número de calle, Número de departamento,Número de piso, M:12 C:8"
          style={{ width: 'auto', height: '150px' }} 
        />
        <Input
          type="text"
          label="Código postal (opcional)"
          fieldName="postalCode"
          register={register}
          error={errors?.postalCode}
        // required
        />
        <PhoneNumber
          label="Teléfono"
          fieldName="phoneNumber"
          control={control}
          error={errors?.phoneNumber}
          required
        />
        <InputEmail
          label="E-mail"
          nameInput={"email"}
          register={register}
          required
          error={errors}
        />
        <Input
          type="text"
          label="Puesto"
          fieldName="positionName"
          register={register}
          error={errors?.positionName}
          required
        />
        {/* <Select
          fieldName="position"
          label="Puesto"
          options={jobPositions}
          register={register}
          error={errors?.position}
          required
          styles="rounded w-full h-[50px]"
        /> */}
      </StyledWrapper.FormContainer>
      <div className="flex flex-col my-10 gap-4">
        <div className="w-full flex justify-end">
          <PrimaryButton
            type="submit"
            text="Cargar empleado"
            styles="bg-red-500 font-bold text-white w-1/3"
            disabled={isLoading}
          />
        </div>
        {apiErrors && (
          <h1 className="text-center font-bold text-red-500 mt-1.5">
            Datos incorrectos
          </h1>
        )}
      </div>
    </form>
  );
}
